// import React from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import contactimgwrapper from '../../Assets/Images/contactimgwrapper.png';
// import { captureeventbaseanalytics } from "../../Libraries/Media";
// import dropdownIcon from '../../Assets/svgs/dropdown_icon.svg';
// import './Contact.css';
// import { toast } from "react-toastify";

// function RequestCall() {
//   const handleAnalytic = () => {
//     captureeventbaseanalytics(
//       "Landing",
//       "BoostBoard_LeadForm",
//       "Boost Board submit btn is clicked."
//     );
//   };

//   const sendEmail = async (event) => {
//     event.preventDefault();
//     const form = event.target;
//     const data = Object.fromEntries(new FormData(form).entries());

//     const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
//     const specialCharRegex = /[<>;]/; 
//     if (!data["cf-fullname"]) {
//       toast.error("Please enter your name");
//     }  else if (!data["cf-email"]){
//       toast.error("Please enter your email");
//     } else if (!data["cf-number"]){
//       toast.error("Please enter your number");
//     } else if (!data["cf-howdidyouhear"]){
//       toast.error("Please enter where did you hear about us.");
//     } else if (data["cf-organizationname"].length > 50) {
//       toast.error("Please enter a valid organization name (max 50 characters)");
//     } else if (specialCharRegex.test(data["cf-organizationname"])) {
//       toast.error("Organization name cannot contain special characters");
//     } else if (!emailRegex.test(data["cf-email"])) {
//       toast.error("Invalid email");
//     } else if (specialCharRegex.test(data["cf-message"])) {
//       toast.error("Query cannot contain special characters");
//     } 
//     else {
//       const body = new FormData();
//       body.append("fullname", data["cf-fullname"]);
//       body.append("organization_name", data["cf-organizationname"]);
//       body.append("email", data["cf-email"]);
//       body.append("phonenumber", data["cf-number"]);
//       body.append("soi", data["cf-howdidyouhear"]);
//       body.append("has_androidtv", data["cf-has-android-tv"]);
//       body.append("message", data["cf-message"]);

//       try {
//         const response = await fetch("https://bbapi.nayatel.com/api/api/website/emails/email_bkp.php", {
//           method: "POST",
//           body: body,
//         });
//         const result = await response.json();
//         if (result.status === "true" && result.message === "Email sent successfully") {
//           toast.success(result.message);
//         } else {
//           toast.error(result.message);
//         }
//       } catch (error) {
//           toast.error(error.message);
//       }
//     }
//   };

//   const showToast = (message, type) => {
//     alert(`${type}: ${message}`);
//   };

//   return (
//     <>
//      <section id="RequestCall" data-stellar-background-ratio="0.5">
//       <Container>
//         <Row>
//           <Col md={12}>
//             <div className="section-title">
//               <h2 className="first_text">
//                 Request <span className="second_text">Call</span>
//               </h2>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//       <section id="contactsub" data-stellar-background-ratio="0.5">
//         <Container>
//           <Row>
//             <Col lg={6} md={12}>
//               <div className="contactimgwrapper">
//                 <img
//                   src={contactimgwrapper}
//                   alt="Contact"
//                   style={{ width: "100%", maxWidth: "470px", height: "470px" }}
//                 />
//               </div>
//             </Col>
//             <Col lg={6} md={12} style={{ paddingTop: "20px" }}>
//               <div className="inquiryformwrapper">
//                 <Form onSubmit={sendEmail} id="form">
//                   <Form.Group controlId="cf-fullname">
//                     <Row>
//                       <Col lg={6} md={12}>
//                         <Form.Label className="nquiryforminputfieldslabel">Full Name</Form.Label>
//                         <Form.Control
//                           type="text"
//                           placeholder="Full Name"
//                           name="cf-fullname"
//                           maxLength="30"
//                           onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
//                         />
//                       </Col>
//                       <Col lg={6} md={12}>
//                         <Form.Label className="nquiryforminputfieldslabel">Organization Name</Form.Label>
//                         <Form.Control
//                           type="text"
//                           placeholder="Organization Name"
//                           name="cf-organizationname"
//                           maxLength="50"
//                           onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
//                         />
//                       </Col>
//                     </Row>
//                   </Form.Group>
                  
//                   <Form.Group controlId="cf-email">
//                     <Form.Label className="nquiryforminputfieldslabel">Email</Form.Label>
//                     <Form.Control
//                       type="email"
//                       placeholder="Your Email"
//                       name="cf-email"
//                       maxLength="50"
//                     />
//                   </Form.Group>
                  
//                   <Form.Group controlId="cf-number">
//                     <Form.Label className="nquiryforminputfieldslabel">Phone Number</Form.Label>
//                     <Form.Control
//                       type="tel"
//                       placeholder="Enter 11 digit number"
//                       name="cf-number"
//                       maxLength="11"
//                       onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
//                     />
//                   </Form.Group>
    
//                   <Form.Group controlId="cf-howdidyouhear">
//                     <Form.Label className="nquiryforminputfieldslabel">How did you hear about Boostboard?</Form.Label>
//                     <div className="dropdown-wrapper">
//                       <Form.Control
//                         as="select"
//                         name="cf-howdidyouhear"
//                         className="dropdown-with-icon"
//                       >
//                         <option value="">Select an option</option>
//                         <option value="web-search">Web search</option>
//                         <option value="social-media">Social media</option>
//                         <option value="email-sms">Email/SMS</option>
//                         <option value="push-notification">Push notification</option>
//                         <option value="friends-family">Friends or family</option>
//                         <option value="outdoor-advertisement">Outdoor advertisement</option>
//                         <option value="other">Other</option>
//                       </Form.Control>
//                       <div className="dropdown-icon">
//                         <img src={dropdownIcon} alt="dropdownIcon"/>
//                       </div>
//                     </div>
//                   </Form.Group>
    
//                   <Form.Group controlId="cf-has-android-tv">
//                     <Form.Label className="nquiryforminputfieldslabel">Do you have Android TV?</Form.Label>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <Form.Check
//                         type="radio"
//                         id="cf-has-android-tv-yes"
//                         label="Yes"
//                         name="cf-has-android-tv"
//                         value="yes"
//                         className="form-check"
//                         inline
//                       />
//                       <Form.Check
//                         type="radio"
//                         id="cf-has-android-tv-no"
//                         label="No"
//                         name="cf-has-android-tv"
//                         value="no"
//                         className="form-check"
//                         inline
//                       />
//                     </div>
//                   </Form.Group>
//                   <Form.Group controlId="cf-message">
//                     <Form.Label className="nquiryforminputfieldslabel">What would you like to know about?</Form.Label>
//                     <Form.Control
//                       type="text"
//                       placeholder="Ex: What will I be charged for 3 screens?"
//                       name="cf-message"
//                       maxLength="50"
//                       onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
//                     />
//                   </Form.Group>
//                   <Button type="submit" className="inquiryforminputbutton" onClick={handleAnalytic}>
//                     Submit
//                   </Button>
//                 </Form>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </section>
    
//     <div data-tf-live="01JH258687SNR5NW6S3NWXQNFE"></div><script src="//embed.typeform.com/next/embed.js"></script>
//     </>
   
//   );
// }

// export default RequestCall;
import React, { useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import contactimgwrapper from '../../Assets/Images/contactimgwrapper.png';
import { captureeventbaseanalytics } from "../../Libraries/Media";
import dropdownIcon from '../../Assets/svgs/dropdown_icon.svg';
import './Contact.css';
import { toast } from "react-toastify";

function RequestCall() {
  const handleAnalytic = () => {
    captureeventbaseanalytics(
      "Landing",
      "BoostBoard_LeadForm",
      "Boost Board submit btn is clicked."
    );
  };

  const sendEmail = async (event) => {
    event.preventDefault();
    const form = event.target;
    const data = Object.fromEntries(new FormData(form).entries());

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const specialCharRegex = /[<>;]/; 
    if (!data["cf-fullname"]) {
      toast.error("Please enter your name");
    }  else if (!data["cf-email"]){
      toast.error("Please enter your email");
    } else if (!data["cf-number"]){
      toast.error("Please enter your number");
    } else if (!data["cf-howdidyouhear"]){
      toast.error("Please enter where did you hear about us.");
    } else if (data["cf-organizationname"].length > 50) {
      toast.error("Please enter a valid organization name (max 50 characters)");
    } else if (specialCharRegex.test(data["cf-organizationname"])) {
      toast.error("Organization name cannot contain special characters");
    } else if (!emailRegex.test(data["cf-email"])) {
      toast.error("Invalid email");
    } else if (specialCharRegex.test(data["cf-message"])) {
      toast.error("Query cannot contain special characters");
    } 
    else {
      const body = new FormData();
      body.append("fullname", data["cf-fullname"]);
      body.append("organization_name", data["cf-organizationname"]);
      body.append("email", data["cf-email"]);
      body.append("phonenumber", data["cf-number"]);
      body.append("soi", data["cf-howdidyouhear"]);
      body.append("has_androidtv", data["cf-has-android-tv"]);
      body.append("message", data["cf-message"]);

      try {
        const response = await fetch("https://bbapi.nayatel.com/api/api/website/emails/email_bkp.php", {
          method: "POST",
          body: body,
        });
        const result = await response.json();
        if (result.status === "true" && result.message === "Email sent successfully") {
          toast.success(result.message);
        } else {
          toast.error(result.message);
        }
      } catch (error) {
          toast.error(error.message);
      }
    }
  };

  const showToast = (message, type) => {
    alert(`${type}: ${message}`);
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <section id="support" data-stellar-background-ratio="0.5" >
        <Container>
          <Row>
            <Col md={12}>
              <div className="section-title">
                <h2 className="first_text">
                  Request <span className="second_text">Call</span>
                </h2>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <section id="contactsub" data-stellar-background-ratio="0.5">
        <Container>
          <Row>
            <Col lg={6} md={12}>
              <div className="contactimgwrapper">
                <img
                  src={contactimgwrapper}
                  alt="Contact"
                  className="form-bottom-margin"
                  style={{width: "100%", maxWidth: "470px" ,height:'495px'}}
                />
              </div>
            </Col>
            <Col lg={6} md={12} style={{ paddingTop: 0 }}>
            <div data-tf-live="01JH258687SNR5NW6S3NWXQNFE"></div>
              {/* <div className="inquiryformwrapper">
                <Form onSubmit={sendEmail} id="form">
                  <Form.Group controlId="cf-fullname">
                    <Row>
                      <Col lg={6} md={12}>
                        <Form.Label className="nquiryforminputfieldslabel">Full Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Full Name"
                          name="cf-fullname"
                          maxLength="30"
                          onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                        />
                      </Col>
                      <Col lg={6} md={12}>
                        <Form.Label className="nquiryforminputfieldslabel">Organization Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Organization Name"
                          name="cf-organizationname"
                          maxLength="50"
                          onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  
                  <Form.Group controlId="cf-email">
                    <Form.Label className="nquiryforminputfieldslabel">Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Your Email"
                      name="cf-email"
                      maxLength="50"
                    />
                  </Form.Group>
                  
                  <Form.Group controlId="cf-number">
                    <Form.Label className="nquiryforminputfieldslabel">Phone Number</Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="Enter 11 digit number"
                      name="cf-number"
                      maxLength="11"
                      onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                    />
                  </Form.Group>
    
                  <Form.Group controlId="cf-howdidyouhear">
                    <Form.Label className="nquiryforminputfieldslabel">How did you hear about Boostboard?</Form.Label>
                    <div className="dropdown-wrapper">
                      <Form.Control
                        as="select"
                        name="cf-howdidyouhear"
                        className="dropdown-with-icon"
                      >
                        <option value="">Select an option</option>
                        <option value="web-search">Web search</option>
                        <option value="social-media">Social media</option>
                        <option value="email-sms">Email/SMS</option>
                        <option value="push-notification">Push notification</option>
                        <option value="friends-family">Friends or family</option>
                        <option value="outdoor-advertisement">Outdoor advertisement</option>
                        <option value="other">Other</option>
                      </Form.Control>
                      <div className="dropdown-icon">
                        <img src={dropdownIcon} alt="dropdownIcon"/>
                      </div>
                    </div>
                  </Form.Group>
    
                  <Form.Group controlId="cf-has-android-tv">
                    <Form.Label className="nquiryforminputfieldslabel">Do you have Android TV?</Form.Label>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <Form.Check
                        type="radio"
                        id="cf-has-android-tv-yes"
                        label="Yes"
                        name="cf-has-android-tv"
                        value="yes"
                        className="form-check"
                        inline
                      />
                      <Form.Check
                        type="radio"
                        id="cf-has-android-tv-no"
                        label="No"
                        name="cf-has-android-tv"
                        value="no"
                        className="form-check"
                        inline
                      />
                    </div>
                  </Form.Group>
                  <Form.Group controlId="cf-message">
                    <Form.Label className="nquiryforminputfieldslabel">What would you like to know about?</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ex: What will I be charged for 3 screens?"
                      name="cf-message"
                      maxLength="50"
                      onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                    />
                  </Form.Group>
                  <Button type="submit" className="inquiryforminputbutton" onClick={handleAnalytic}>
                    Submit
                  </Button>
                </Form>
              </div> */}
            </Col>
          </Row>
        </Container>
      </section>
      
    
    
    </>
  );
}

export default RequestCall;



